module.exports = __webpack_public_path__ + "img/content3.3305a502.png";